const avisosFake = {
  aviso: {
    localizacion: 'Quinto, Pichincha',
    idPais: 9,
  },
}

export default avisosFake
